class GA4 {
  static GTAGID = 'GTM-TVPKFMV'
}

export default GA4
